import { DOCUMENT } from '@angular/common'
import {
  DestroyRef,
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { distinctUntilChanged } from 'rxjs/operators'
import { FeatureFlagService } from '../feature-flag/feature-flag.service'
import { NewThemeService } from './new-theme.service'

export const NEW_THEME_FLAG = 'webapps-new-theme'

/** Value of `data-theme` on `<html>` that switches the `--wm-*` tokens to the 2026 theme. */
export const NEW_THEME_NAME = '2026'

/** Sets `data-theme="2026"` on `<html>` while the `webapps-new-theme` flag is on, and removes it when it goes off.
 * `NewThemeService.enabled` follows, once the attribute is set, so token values read after it are the new ones. */
export const provideNewThemeFlag = (): EnvironmentProviders =>
  provideEnvironmentInitializer(() => {
    const root = inject(DOCUMENT).documentElement
    const newTheme = inject(NewThemeService)

    inject(FeatureFlagService)
      .watch(NEW_THEME_FLAG, false)
      .pipe(distinctUntilChanged(), takeUntilDestroyed(inject(DestroyRef)))
      .subscribe((enabled) => {
        if (enabled) {
          root.setAttribute('data-theme', NEW_THEME_NAME)
        } else {
          root.removeAttribute('data-theme')
        }
        newTheme.enabled.set(enabled)
      })
  })
